import { Controller, useFormContext } from "react-hook-form";
import styles from "./AppColorPicker.module.scss";
import { useAppContext } from "../../../../../AppContext";
import { classNames } from "primereact/utils";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { ColorPicker } from "primereact/colorpicker";
import { useRef } from "react";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface IAppColorPickerProps {
  className?: string;
  name: string;
  label?: string;
  required?: boolean;
  width?: string;
  disabled?: boolean;
  inline?: boolean;
}

export const AppColorPicker = ({
  className,
  name,
  label,
  required = false,
  width,
  disabled,
  inline = false,
}: IAppColorPickerProps) => {
  const { control } = useFormContext();
  const { isDesktopOrTablet } = useAppContext();
  const colorPickerRef = useRef<HTMLDivElement | null>(null);

  if (!width) {
    if (isDesktopOrTablet) {
      width = "600px";
    } else {
      width = dvSize("80dvw");
    }
  }

  const handleOpen = () => {
    if (!inline && colorPickerRef.current) {
      // prevent toggling if it's already open
      const isOpen = document.querySelector(".p-colorpicker-panel") !== null;
      if (isOpen) return;

      const previewBox = colorPickerRef.current.querySelector(
        ".p-colorpicker-preview"
      ) as HTMLElement;

      previewBox?.click();
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        return (
          <div
            style={{ width }}
            className={classNames(className, styles.root, {
              [styles.root_disabled]: disabled,
            })}
            onClick={handleOpen}
            ref={colorPickerRef}
          >
            <ColorPicker
              id={field.name}
              value={field.value}
              onChange={(e) => field.onChange(e.value)}
              className={styles.root_input}
              disabled={disabled}
              inline={inline}
            />
            <RenderWhen condition={!!label}>
              <div
                className={classNames(styles.root_label, {
                  [styles.root_label_interacted_with]:
                    !!field.value || fieldState.isTouched,
                  [styles.root_label_error]: !!fieldState.error?.message,
                })}
              >
                {label}
                {required ? "*" : ""}
              </div>
            </RenderWhen>
          </div>
        );
      }}
    />
  );
};
